/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionsCell/view.blocks to change it.
import DiagnosisAction from './DiagnosisAction/index'
import ImagesAction from './ImagesAction/index'
import React from 'react'
import ToothChartAction from './ToothChartAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ActionsCell({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/ActionsCell"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ActionsCell.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ToothChartAction
  viewPath={`${viewPath}/ToothChartAction`}
/>
<ImagesAction
  viewPath={`${viewPath}/ImagesAction`}
/>
<DiagnosisAction
  viewPath={`${viewPath}/DiagnosisAction`}
/>
</div>
{children}
</React.Fragment>)
}